import React from 'react';
import Panel from '../components/Panel';
import auth from '../lib/auth';
import helpers from '../lib/helpers';
import store, {actions} from '../store';
import InputSelect from '../components/InputSelect';
import _ from 'lodash';
import Input from '../components/Input';
import {Alert} from 'reactstrap';

export default class ManageUsers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initializing: true,
      data: {},
      submitting: false,
      fetching: false,
      saved: false,
      deleting: false,
      deleted: false,
    };

    this.user = {};

    this.handleUserSelect = this.handleUserSelect.bind(this);
    this.handleGroupSelect = this.handleGroupSelect.bind(this);
    this.save = this.save.bind(this);
    this.remove = this.remove.bind(this);
  }

  async componentDidMount() {
    let [user, users, groups] = await Promise.all([
      auth.user(),
      store.dispatch(actions.users.fetchAll()),
      store.dispatch(actions.groups.fetchAll()),
    ]);

    _.forEach(groups, (group) => {
      if (_.isArray(group.users)) {
        _.forEach(users, (user) => {
          if (group.users.includes(user.userId)) {
            if (!user.groups) {
              user.groups = [];
            }
            user.groups.push(group);
          }
        });
      }
    });

    this.user = user;

    this.setState({
      initializing: false,
      user,
      users,
      groups,
    });
  }

  save() {
    this.setState({
      submitting: true,
    });

    let data = Object.assign({}, this.state.data);
    data.groups = _.map(data.groups || [], (group) => group.groupId);

    store.dispatch(actions.users.createOrUpdate(data)).
        then((result) => {
          result.groups = _.map(result.groups || [], (groupId) => {
            return _.find(this.state.groups, (group) => {
              return group.groupId === groupId;
            });
          });
          if (this.state.data.userId) {
            this.setState({
              saved: true,
              submitting: false,
              users: _.map(this.state.users, (user) => {
                if (this.state.data.userId ===
                    user.userId) return this.state.data;
                return user;
              }),
            });
          } else {
            this.setState({
              data: result,
              submitting: false,
              saved: true,
              users: this.state.users.concat([result]),
            });
          }

          setTimeout(() => {
            this.setState({
              saved: false,
            });
          }, 3000);
        }).
        catch(err => {
          this.setState({
            submitting: false,
          });
          alert(err.message);
          console.error(err);
        });
  }

  remove() {
    this.setState({
      deleting: true,
    });

    store.dispatch(actions.users.remove(this.state.data.userId)).
        then(result => {
          this.setState({
            deleted: true,
            deleting: false,
            users: _.filter(this.state.users, (user) => {
              return (this.state.data.userId !==
                  user.userId);
            }),
            data: {},
          });
          setTimeout(() => {
            this.setState({
              deleted: false,
            });
          }, 3000);
        }).
        catch(err => {
          alert(err.message);
          this.setState({
            deleting: false,
          });
        });
  }

  handleUserSelect(data) {

    if (!_.isObject(data)) {
      this.setState({
        data: {},
      });
    } else if (_.isObject(data.value)) {
      this.setState({
        fetching: true,
        data: {},
      });
      let user = data.value;
      store.dispatch(actions.users.fetch(user.userId)).then((result) => {
        result.groups = _.map(result.groups || [], (groupId) => {
          return _.find(this.state.groups, (group) => {
            return group.groupId === groupId;
          });
        });
        this.setState({
          fetching: false,
          data: result,
        });
      }).catch(err => {
        alert(err.message);
        this.setState({
          fetching: false,
        });
      });
    } else if (_.isString(data.value)) {
      let emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (emailRegex.test(data.value.toLowerCase())) {
        this.setState({
          data: {
            email: data.value,
          },
        });
      }
    }
  }

  handleFormChange(name, value) {
    this.setState({
      data: Object.assign({}, this.state.data, {
        [name]: value,
      }),
    });
  }

  handleGroupSelect(data) {
    this.setState({
      data: Object.assign({}, this.state.data, {
        groups: _.map(data, (item) => item.value),
      }),
    });
  }

  render() {
    return this.state.initializing ? helpers.showPanelLoading() :
        !this.user.isAdmin ? helpers.showPageNotFound() : (
            <Panel title="Manage Users">
              <Alert color="success" isOpen={this.state.saved}>
                Account Saved
              </Alert>
              <Alert color="info" isOpen={this.state.deleted}>
                Account Deleted
              </Alert>
              <InputSelect
                  label="Email Address"
                  placeholder={this.state.fetching ?
                      'Fetching...' :
                      'New User or Select Existing'}
                  options={_.map(this.state.users, (user) => {
                    return {label: user.email, value: user};
                  })}
                  onChange={this.handleUserSelect}
                  creatable
                  value={this.state.data.email ?
                      {
                        label: this.state.data.email,
                        value: this.state.data.email,
                      } :
                      null}
                  promptTextCreator={(label) => `Create an account for '${label}'`}
              />
              <Input label="First Name"
                     disabled={!this.state.data.email}
                     value={this.state.data.nickname || ''}
                     onChange={this.handleFormChange.bind(this, 'nickname')}
              />
              <Input label="Last Name"
                     disabled={!this.state.data.email}
                     value={this.state.data.family_name || ''}
                     onChange={this.handleFormChange.bind(this,
                         'family_name')}
              />
              <Input label="Mobile Number"
                     disabled={!this.state.data.email}
                     value={this.state.data.phone_number || ''}
                     onChange={this.handleFormChange.bind(this,
                         'phone_number')}
              />
              <Input type="checkbox"
                     disabled={!this.state.data.email}
                     checked={this.state.data.admin || false}
                     label="System Administrator"
                     onChange={this.handleFormChange.bind(this, 'admin')}
              />
              <Input type="checkbox"
                     disabled={!this.state.data.email}
                     checked={this.state.data.usemfa || false}
                     label="Use 2FA"
                     onChange={this.handleFormChange.bind(this, 'usemfa')}
              />
              <InputSelect
                  disabled={!this.state.data.email}
                  label="Group Membership"
                  placeholder="Select Group Memberships"
                  options={_.map(this.state.groups, (group) => {
                    return {label: group.groupName, value: group};
                  })}
                  value={_.map(this.state.data.groups || [], (group) => {
                    return {label: group.groupName, value: group};
                  })}
                  onChange={this.handleGroupSelect}
                  multi
              />
              <div className="container-fluid clearfix" style={{
                borderTop: '1px solid #ccc',
                padding: '30px 60px 10px',
                margin: '0 -20px',
                width: 'auto',
              }}>
                <button className="btn btn-outline-danger pull-left px-5"
                        disabled={this.state.submitting ||
                        !this.state.data.userId || this.state.deleting}
                        onClick={this.remove}
                >
                  {this.state.deleting ? 'Deleting...' : 'Delete'}
                </button>
                <button className="btn btn-purple pull-right px-5"
                        disabled={this.state.submitting ||
                        !this.state.data.email || this.state.deleting}
                        onClick={this.save}
                >
                  {this.state.submitting ? 'Saving...' : (this.state.data.userId ? 'Save' : 'Create')}
                </button>
              </div>
            </Panel>
        );
  }
}


// WEBPACK FOOTER //
// ./src/containers/ManageUsers.js